import 'twin.macro';
import React from 'react';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { Tag } from '@teetsh/app/src/components/Tag';
import getPeriodeAndWeek from '@teetsh/app/src/components/PeriodeWeekTag/getPeriodeAndWeek';
import { useTranslation } from 'react-i18next';
import FullSmallDot from 'components/Icons/icons/FullSmallDot';

interface Props {
  minimal?: boolean;
  date: Date;
}

export function PeriodeWeekTag(props: Props) {
  const { schoolyear } = useSchoolSchoolyear();
  const { t } = useTranslation(['schoolyearSettings']);
  const periodeAndWeek = getPeriodeAndWeek(props.date, schoolyear.zone);
  if (!periodeAndWeek) {
    return null;
  }
  const { periode, week, totalWeeks } = periodeAndWeek;
  if (props.minimal) {
    return (
      <div tw="text-xs text-muted gap-x-2 flex items-center">
        <span>
          {t('schoolyearSettings:week_n_of_m', {
            week,
            totalWeeks,
          })}
        </span>
        <FullSmallDot />
        <span>{periode}</span>
      </div>
    );
  }

  return (
    <div>
      <Tag>
        {t('schoolyearSettings:week_n_of_m', {
          week,
          totalWeeks,
        })}
      </Tag>
      <Tag tw="mr-2">{periode}</Tag>
    </div>
  );
}
